.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* The code is read digit by digit, so it is set large and spaced. */
.form input {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.3em;
}

.links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.link {
  display: flex;
  align-items: center;
  min-height: 44px;
  font-weight: 700;
  text-underline-offset: 3px;
}
